import React from 'react';

const AppsContext = React.createContext();

export default AppsContext;
